export default "__VITE_ASSET__d2a1095f__"